import { Link } from "react-router-dom";

import logob from "../assets/winglo.png";
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import phonee from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";

const Footer = () => {
  return (
    <div className="bg-[#131519] text-white snap-section">
      
      <footer className="px-4 sm:px-6 lg:px-12 py-6 lg:py-12">
        <div className="flex flex-col gap-8 lg:gap-12">
        
          <div className="flex flex-col lg:flex-row flex-wrap justify-between gap-10 text-[16px]">

            <div className="w-full lg:w-[30%]">
              <a href="/" aria-label="Winglo Home">
                <img src={logob} alt="Winglo logo" className="mb-6 max-w-[180px]" />
              </a>
              <p className="text-[#d4d4d4] leading-relaxed">
                Winglo Solution Pvt Ltd is a cloud-based IT product company
                headquartered in Chennai, delivering scalable software
                solutions for Healthcare and Education domains.
              </p>

              <div className="flex gap-4 mt-6 flex-wrap">
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <img src={inst} alt="Instagram" className="w-8 h-8" />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <img src={face} alt="Facebook" className="w-8 h-8" />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <img src={you} alt="YouTube" className="w-8 h-8" />
                </a>
                <a href="https://www.linkedin.com/company/winglo-solutions-pvt-ltd/" target="_blank" rel="noopener noreferrer">
                  <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <img src={twi} alt="Twitter" className="w-8 h-8" />
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-3 border-b-2 border-[#FF7A00] inline-block">
                PRODUCTS
              </h4>
              <ul className="space-y-2 text-[#d4d4d4]">
                <li><Link to="/products/healthcare" className="hover:text-white">LIMS Platform</Link></li>
                <li><Link to="/products/quality-management-system" className="hover:text-white">Quality Management System</Link></li>
                <li><Link to="/products/inventory" className="hover:text-white">Inventory Management System</Link></li>
                <li><Link to="/products/veterinary" className="hover:text-white">Veterinary LIMS</Link></li>
              </ul>
            </div>

  
            <div>
              <h4 className="font-semibold mb-3 border-b-2 border-[#FF7A00] inline-block">
                COMPANY
              </h4>
              <ul className="space-y-2 text-[#d4d4d4]">
                <li><Link to="/about" className="hover:text-white">About Us</Link></li>
                {/* <li><Link to="/careers" className="hover:text-white">Why Choose us</Link></li> */}
                <li><Link to="/clients" className="hover:text-white">Clients</Link></li>
                <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              </ul>
            </div>


            <div>
              <h4 className="font-semibold mb-3 border-b-2 border-[#FF7A00] inline-block">
                CONTACT US
              </h4>

              <div className="flex items-start gap-3 mb-3">
                <img src={phonee} alt="phone" className="w-8 h-8 mt-1" />
                <div>
                  <p className="text-[#999] text-sm">Phone</p>
                  <a href="tel:9842009463" className="hover:underline">
                    9842009463
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3 mb-3">
                <img src={mail} alt="email" className="w-8 h-8 mt-1" />
                <div>
                  <p className="text-[#999] text-sm">Email</p>
                  <a href="mailto:contact@winglolive.com" className="hover:underline">
                    contact@winglolive.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <img src={loc} alt="location" className="w-8 h-8 mt-1" />
                <div>
                  <p className="text-[#999] text-sm">Location</p>
                  <a href="https://www.google.co.in/maps/place/Spacelance,+OMR,+Chennai+-+Virtual+Office+and+Desk+Space+in+Perungudi/@12.97259,80.2493113,17z/data=!3m1!4b1!4m6!3m5!1s0x3a525d1fc3584163:0x656d9d542aa3a9aa!8m2!3d12.97259!4d80.2518862!16s%2Fg%2F11rzjw6qbj?entry=ttu&g_ep=EgoyMDI2MDQxNC4wIKXMDSoASAFQAw%3D%3D"
            target="_blank" className="hover:underline">
                    Spacelance Office Solutions Pvt. Ltd.,<br />  4/608, G1, V.O.C. Street,<br />
                    Perungudi, OMR, Chennai,<br /> Tamil Nadu 600041
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </footer>

  
      <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex justify-center items-center gap-3 py-4 px-6">
        <p>© 2026 Winglo Solution Pvt Ltd. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
